"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var LoadGlobal_1 = __importDefault(require("./LoadGlobal"));
var Locale_1 = __importDefault(require("./Locale"));
var Router_1 = __importDefault(require("./Router"));
var Settings_1 = __importDefault(require("./Settings"));
var User_1 = __importDefault(require("./User"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var Root = function (_a) {
    var user = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).user;
    return ((0, jsx_runtime_1.jsx)(User_1.default, { children: (0, jsx_runtime_1.jsx)(Settings_1.default, { children: (0, jsx_runtime_1.jsx)(Locale_1.default, { children: user ? ((0, jsx_runtime_1.jsx)(LoadGlobal_1.default, { children: (0, jsx_runtime_1.jsx)(Router_1.default, {}) })) : ((0, jsx_runtime_1.jsx)(Router_1.default, {})) }) }) }));
};
exports.default = Root;
